/**
 * Resilient API Router
 * Increased timeout to 10s to accommodate Stripe API latency.
 */
export const apiRequest = async (endpoint, options = {}) => {
  const baseUrl = 'https://us-central1-expert-guru-469c4.cloudfunctions.net/api';
  const url = `${baseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout for Stripe

    const response = await fetch(url, {
      method: options.method || 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      body: options.body,
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || `Server error: ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error("API Request Failed:", error);
    return { 
      error: true, 
      message: error.name === 'AbortError' ? 'Request timed out. Please try again.' : error.message 
    };
  }
};